import { render, staticRenderFns } from "./ConferenceAddress.vue?vue&type=template&id=18d70e90&scoped=true&"
import script from "./ConferenceAddress.vue?vue&type=script&lang=js&"
export * from "./ConferenceAddress.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceAddress.vue?vue&type=style&index=0&id=18d70e90&scoped=true&lang=scss&"
import style1 from "./ConferenceAddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d70e90",
  null
  
)

export default component.exports